var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteIco = function SvgQuoteIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "quote_ico",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0C23.63 0 30.5 6.21115 30.5 13.6765C30.5 21.7689 23.63 27.3529 15.5 27.3529C13.5246 27.3529 11.6235 27.0233 9.87737 26.408C7.65095 27.6486 4.51664 29.1781 1.38232 29.9998L4.76347 23.3809C2.13908 20.9835 0.5 17.6292 0.5 13.6765C0.5 6.21115 7.37 0 15.5 0ZM14.6174 12.3555C14.6174 9.35271 12.9037 7.94141 10.9285 7.94141C8.69194 7.94141 7.53008 9.71304 7.55913 11.845C7.55913 14.6376 9.59238 15.3583 10.8414 15.4483C10.9285 16.199 9.99903 17.4902 8.89526 18.2409L9.33096 19.412C11.219 19.1718 14.6174 16.6494 14.6174 12.3555ZM23.4411 12.3555C23.4411 9.35271 21.7274 7.94141 19.7522 7.94141C17.5157 7.94141 16.3538 9.71304 16.3829 11.845C16.3829 14.6376 18.4161 15.3583 19.6651 15.4483C19.7522 16.199 18.8228 17.4902 17.719 18.2409L18.1547 19.412C20.0427 19.1718 23.4411 16.6494 23.4411 12.3555Z",
    fill: "black",
    fillOpacity: 0.35
  })));
};
export default SvgQuoteIco;